module.exports = __webpack_public_path__ + "static/media/visa.2cca1aa4.png";